/* Extends Shrine's existing quantity breaks, upsells and product form. */
(() => {
  const states = new WeakMap();
  function setup(section) {
    if (states.has(section)) return;
    const breaks = section.querySelector('quantity-breaks');
    const packBlocks = [...section.querySelectorAll('[data-mg-upsell-block]')];
    const forms = [...section.querySelectorAll('product-form[data-mg-button-label]')];
    if (!forms.length && !packBlocks.length) return;
    const memory = new WeakMap();
    const slots = new Map();
    let queued = false;
    if (document.body.dataset.mgTheme === 'true') section.classList.add('mg-shine');
    if (breaks) {
      for (const label of breaks.querySelectorAll('.quantity-break')) {
        const number = label.dataset.input?.replace('input_', '');
        if (!number) continue;
        const slot = document.createElement('div');
        slot.className = 'mg-pack-slot';
        slot.hidden = true;
        slot.dataset.mgSlot = number;
        if (breaks.dataset.mgAddonsHeading) { const heading = document.createElement('p'); heading.className = 'mg-pack-heading'; heading.textContent = breaks.dataset.mgAddonsHeading; slot.append(heading); }
        label.after(slot);
        slots.set(number, { slot, label });
      }
    }
    for (const block of packBlocks) {
      const pack = block.dataset.mgPack;
      if (pack === 'outside') continue;
      const target = slots.get(pack);
      if (target) target.slot.append(block);
      else block.hidden = true;
      for (const item of block.querySelectorAll('product-info-upsell')) {
        memory.set(item, { selected: item.dataset.selected === 'true', active: true });
      }
    }
    function sync() {
      queued = false;
      const selected = breaks?.querySelector('input[name="quantity"]:checked')?.dataset.input?.replace('input_', '');
      for (const block of packBlocks) {
        const pack = block.dataset.mgPack;
        if (pack === 'outside') continue;
        const active = pack === selected && slots.has(pack);
        block.hidden = !active;
        for (const item of block.querySelectorAll('product-info-upsell')) {
          const last = memory.get(item) || { selected: false, active: false };
          if (last.active) last.selected = item.dataset.selected === 'true';
          const next = active && last.selected ? 'true' : 'false';
          if (item.dataset.selected !== next) item.dataset.selected = next;
          last.active = active;
          memory.set(item, last);
        }
      }
      for (const [number, { slot, label }] of slots) {
        const visible = number === selected && !!slot.querySelector('product-info-upsell');
        slot.hidden = !visible;
        label.classList.toggle('mg-has-addons', visible);
      }
      for (const element of forms) {
        // Shrine builds one Ajax request from this collection. Repeating a variant
        // makes its existing aggregation count the requested addon quantity.
        const sid = element.dataset.section;
        const all = [...section.querySelectorAll(`.product-info-upsell-${CSS.escape(sid)}`)];
        for (const item of all) {
          const compare = Number(item.dataset.mgComparePrice);
          const price = Number(item.price ?? item.dataset.price);
          const label = item.querySelector('.upsell__price .compare-price');
          if (label && compare > price && item.dataset.mgCompareMoney) {
            if (label.textContent !== item.dataset.mgCompareMoney) label.textContent = item.dataset.mgCompareMoney;
            label.classList.remove('hidden');
          }
        }
        element.upsells = all.flatMap(item => Array.from({ length: Math.max(1, Math.min(10, Number(item.closest('[data-mg-extra-quantity]')?.dataset.mgExtraQuantity) || 1)) }, () => item));
        const hasExtras = all.some(item => item.dataset.selected === 'true');
        const express = element.querySelector('[data-mg-express]');
        const note = element.querySelector('[data-mg-express-note]');
        if (express) express.hidden = hasExtras;
        if (note) note.hidden = !hasExtras;
        const button = element.querySelector('button[name="add"]');
        const text = button?.querySelector('.main-atc__label__text');
        const customLabel = element.dataset.mgButtonLabel;
        if (text && customLabel && !button.disabled && button.dataset.unavailable !== 'true' && text.textContent.trim() !== customLabel) text.textContent = customLabel;
      }
    }
    const queue = () => { if (!queued) { queued = true; queueMicrotask(sync); } };
    section.addEventListener('change', queue);
    // Sync before Shrine's target-level submission handler.
    section.addEventListener('submit', sync, true);
    const observer = new MutationObserver(queue);
    observer.observe(section, { attributes: true, attributeFilter: ['data-selected', 'disabled', 'data-unavailable'], childList: true, subtree: true, characterData: true });
    states.set(section, { observer, queue, sync });
    sync();
  }
  function init(root = document) {
    const sections = [...root.querySelectorAll('.shopify-section')];
    if (root.matches?.('.shopify-section')) sections.unshift(root);
    sections.forEach(setup);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const state = states.get(event.target);
    state?.observer.disconnect();
    states.delete(event.target);
  });
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest?.('[data-mg-upsell-block]') || event.target.querySelector?.('[data-mg-upsell-block]');
    if (!block || block.dataset.mgPack === 'outside') return;
    const section = block.closest('.shopify-section');
    const radio = section?.querySelector(`quantity-breaks input[data-input="input_${block.dataset.mgPack}"]`);
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-mg-scroll-product]')) return;
    const target = document.querySelector('product-info')?.closest('.shopify-section');
    if (target) { event.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
